import styled from 'styled-components';

const Wrapper = styled.table`
    thead>tr>td,
    thead>tr>th {
        font-family: Inter;
        font-style: normal;
        font-weight: bold;
        font-size: 12px;
        line-height: 18px;
        color: #737981;
        background: #F8F8F9;
        border: 0px;
        border-bottom: 1px solid #E2E4E8 !important;
        padding: 16px;
        vertical-align: middle;
    }
    tbody>tr>td,
    tbody>tr>th {
        font-family: Inter;
        font-style: normal;
        font-weight: normal;
        font-size: 16px;
        line-height: 24px;
        color: #26292D !important;
        border-bottom: 1px solid #E2E4E8 !important;
        padding: 16px;
        vertical-align: middle;
    }
    tbody>tr:nth-child(odd) > td,
    tbody>tr:nth-child(odd) > th{
        background : #FFFFFF;
    }
    tbody>tr:nth-child(even) > td,
    tbody>tr:nth-child(even) > th{
        background: #F8F8F9;
    }

    tbody>tr:nth-last-child(1) > td,
    tbody>tr:nth-last-child(1) > th{
        border-bottom: 0px !important;
    }

    margin-bottom: 0px;
`

export default Wrapper;